import auth from '../utils/auth'
import rest from '../utils/rest'

const tokenRequest = {
  scopes: ['openid', 'profile', 'User.Read'],
  forceRefresh: false // set this to "true" if you would like to skip a cached token and go to the server
};

export default {
  async getUserProfile() {
    const url = 'https://graph.microsoft.com/beta/me/';
    const options = await auth.getOptions(tokenRequest, 'GET');

    return await rest.call(url, options);
  },
  async getAppRoleAssignments() {
     //Use Enterprise Application AIG object Id to app role assignments
    const url = 'https://graph.microsoft.com/beta/me/appRoleAssignments?$filter=resourceId eq 3cc8abd3-3ac3-4936-8494-8f233484ae7d';
    console.log(url);
    const options = await auth.getOptions(tokenRequest, 'GET');
    return await rest.call(url, options);
  }
}